import firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";

var firebaseConfig = {
    apiKey: "AIzaSyBPZ2O3-AwEnCHpy-gGHUsh43nHqvyB928",
    authDomain: "diary-survey-manager.firebaseapp.com",
    databaseURL: "https://diary-survey-manager.firebaseio.com",
    projectId: "diary-survey-manager",
    storageBucket: "diary-survey-manager.appspot.com",
    messagingSenderId: "881596806055",
    appId: "1:881596806055:web:e97edd3900010018fd3c82", 
    measurementId: "G-8542V15GK1"
  };
  firebase.initializeApp(firebaseConfig);

export {firebase}